import SpriteSymbol from "../../../hac-ng/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../hac-ng/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "circle-plus",
  "use": "circle-plus-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol fill=\"currentColor\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"circle-plus\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M8.5 15a7.5 7.5 0 110-15 7.5 7.5 0 010 15zM9 7h2.5s.5 0 .5.5-.5.5-.5.5H9v2.5s0 .5-.5.5-.5-.5-.5-.5V8H5.5S5 8 5 7.5s.5-.5.5-.5H8V4.5s0-.5.5-.5.5.5.5.5V7zm6 .5a6.5 6.5 0 11-13 0 6.5 6.5 0 0113 0z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol